import 'reactjs-popup/dist/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { toggleOrientationModalState } from 'store/slices/ChangeOrientationModalSlice';
import { changeFacetOrientation } from './api';
import { changePanel } from 'store/slices/RoofDataSlice/roofDataSlice';
import { toggleWarningModalState } from 'store/slices/WarningSlice';
import { useMutation } from 'react-query';
import { appToast } from '../../../Basic/CustomToast';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import useStartShadingRecalc from 'hooks/useStartShadingRecalc';

const popupMsg = 'Are you sure you want to change the facet\'s orientation?';
export default function ChangeOrientation() {
	const { open } = useSelector((state: RootState) => state.changeOrientationModal.data);
	const { selectedRoofIndex, deletedRoofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { allRoofSegs, uuid, panel, designType } = useSelector((state: RootState) => state.roofData.data);

	const dispatch = useDispatch<AppDispatch>();
	const startShadingRecalc = useStartShadingRecalc();

	const changeFacetOrientationQuery = useMutation(
		async () => {
			if (!selectedRoofIndex) return;
			const selectedRoof = allRoofSegs.find(r => r.id === selectedRoofIndex);
			const { panelsCount, shadingStatus } = await changeFacetOrientation(
				selectedRoofIndex, uuid, panel.key, selectedRoof?.orientation as string, !!selectedRoof?.userMapped
			);
			return { panelsCount, selectedRoofIndex, shadingStatus };
		},
		{
			onSuccess(data) {
				if (data?.panelsCount == 0) {
					dispatch(toggleWarningModalState({
						open: true,
						warningMessage: 'We are not able to generate any panel in this orientation.',
						selectedRoofIdx: data?.selectedRoofIndex,
						noOfPanels: data?.panelsCount
					}));
				}
				else if (data && data.panelsCount < 3) {
					dispatch(toggleWarningModalState({
						open: true,
						warningMessage: 'We are not able to generate more than 2 panels in this orientation, do you still want to continue?',
						selectedRoofIdx: data?.selectedRoofIndex,
						noOfPanels: data?.panelsCount
					}));
				}
				dispatch(changePanel({ uuid, panelKey: panel.key, designType: designType }));
				dispatch(toggleOrientationModalState({ open: false, isLoading: false }));
				// Rotating a ground mount moved the racks the shaded flux is baked from — the
				// API flagged the rebuild it owes, so start it in the background.
				startShadingRecalc(data?.shadingStatus);
			},
			onError() {
				appToast.error('something went wrong, please try again');
			},
			mutationKey: 'changeFacetOrientation'
		});

	return (
		<ConfirmationModal
			open={open}
			message={popupMsg}
			onCancel={() => {
				dispatch(toggleOrientationModalState({ open: false, isLoading: false }));
			}}
			onConfirm={() => {
				if (!selectedRoofIndex) return;
				if (deletedRoofIndexes.includes(selectedRoofIndex)) return;
				changeFacetOrientationQuery.mutate();
				dispatch(toggleOrientationModalState({ open: false, isLoading: true }));
			}}
		/>
	);
}